import { render } from "./TechnicianForm.vue?vue&type=template&id=4cc35fca"
import script from "./TechnicianForm.vue?vue&type=script&lang=js"
export * from "./TechnicianForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__